'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverTitle", {
    enumerable: true,
    get: function() {
        return TeachingPopoverTitle;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverTitle = require("./useTeachingPopoverTitle");
const _renderTeachingPopoverTitle = require("./renderTeachingPopoverTitle");
const _useTeachingPopoverTitleStylesstyles = require("./useTeachingPopoverTitleStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TeachingPopoverTitle = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverTitle.useTeachingPopoverTitle_unstable)(props, ref);
    (0, _useTeachingPopoverTitleStylesstyles.useTeachingPopoverTitleStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTeachingPopoverTitleStyles_unstable')(state);
    return (0, _renderTeachingPopoverTitle.renderTeachingPopoverTitle_unstable)(state);
});
TeachingPopoverTitle.displayName = 'TeachingPopoverTitle';
